<template>
  <div class="ml-3">
    <div class="row mb-3">
      <div class="col-12">
        <i class="fas fa-clock text-orange mr-2"></i>
        <strong class="">Historial de Citas Canceladas</strong>
      </div>
    </div>
    <time-line class="mt-4">
      <time-line-item
        v-for="detail in history"
        :key="detail.statusCreateDate"
        icon="far fa-calendar-times "
      >
        <template #date>
          <span class="body-2">{{ $formatDate(detail.createdDate) }}</span>
          <p class="body-3">
            {{ $formatDate(detail.createdDate, $templateDate.hour) }}
          </p>
        </template>
        <div class="row my-2">
          <div class="col-12 col-md-2 d-flex flex-column align-items-center ">
            <label class="text-muted">
              Estatus:
            </label>
            <div class="balloon-fixed">
              <custom-balloon text="Cancelada" background-color="#d5b89a" dot />
            </div>
          </div>
          <div class="col-12 col-md-2 px-2">
            <div class="d-flex flex-column align-items-center ">
              <label class="text-muted">
                Número de Cita:
              </label>
              <span>
                {{ detail.appointmentNumber | empty }}
              </span>
            </div>
          </div>
          <div class="col-12 col-md-2 px-2">
            <div class="d-flex flex-column align-items-center ">
              <label class="text-muted">
                Fecha de Cita:
              </label>
              <span>
                {{ $formatDate(detail.startDate) }}
              </span>
            </div>
          </div>
          <div class="col-12 col-md-2 px-2">
            <div class="d-flex flex-column align-items-center ">
              <label class="text-muted">
                Horario:
              </label>
              <span>
                {{ $formatDate(detail.startDate, $templateDate.hour) }}
              </span>
            </div>
          </div>
          <div class="col-12 col-md-2 px-2">
            <div class="d-flex flex-column align-items-center ">
              <label class="text-muted">
                Razón:
              </label>
              <span>
                {{ detail.reason | empty }}
              </span>
            </div>
          </div>
        </div>
        <div class="row bg-white my-2 p-3 rounded-lg">
          <div class="col-12">
            <i class="fas fa-info-circle text-orange mr-2"></i>
            <label class="text-muted">Comentario:</label>
          </div>
          <div class="col-12 ">
            <p>
              {{ detail.comment | empty }}
            </p>
          </div>
        </div>
      </time-line-item>
    </time-line>
    <pagination
      v-if="pagination.totalItemCount > pagination.pageSize"
      :data="pagination"
      :page-size="pagination.pageSize"
      @pagination-go-page="onPageChange"
    />
  </div>
</template>
<script>
import appointmentServices from '@/services/api/appointment.api';
import { TimeLine, TimeLineItem } from '@/components/common/timeline';
import CustomBalloon from 'custom-balloon';
import Pagination from 'pagination';

const DEFAULT_PAGE_SIZE = 5;

export default {
  name: 'CanceledAppointmentHistory',
  components: {
    TimeLine,
    TimeLineItem,
    CustomBalloon,
    Pagination,
  },
  props: {
    clientAppointmentId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      history: [],
      pagination: {
        count: 0,
        currentPage: 1,
        pageCount: 1,
        totalItemCount: 0,
        pageSize: DEFAULT_PAGE_SIZE,
      },
    };
  },
  mounted() {
    this.fetchAppointmentHistory();
  },
  methods: {
    async fetchAppointmentHistory(page = 1) {
      const { data } = await appointmentServices.getCanceledAppointmentHistory({
        clientAppointmentId: this.clientAppointmentId,
        currentPage: page,
        pageCount: DEFAULT_PAGE_SIZE,
      });
      this.history = data.data;

      this.pagination = {
        pageSize: DEFAULT_PAGE_SIZE,
        totalItemCount: data.totalItemCount,
        pageCount: data.pageCount,
        currentPage: data.currentPage,
        count: data.count,
      };
    },
    async onPageChange(page) {
      this.fetchAppointmentHistory(page);
    },
  },
};
</script>
